// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-item {
  /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */
}
.menu-item .mat-mdc-button {
  width: 100%;
  font-weight: 400;
  text-transform: uppercase;
  padding-left: 16px;
}
.menu-item .mat-mdc-button .mat-icon.menu-expand-icon {
  position: absolute;
  right: 10px;
  top: 10px;
}
.menu-item .mat-mdc-button.expanded .menu-expand-icon {
  transform: rotate(180deg);
}

.sub-menu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s ease-out;
}
.sub-menu .sub-menu .mat-mdc-button {
  padding-left: 60px;
}
.sub-menu .sub-menu .sub-menu .mat-mdc-button {
  padding-left: 80px;
}
.sub-menu .sub-menu .sub-menu .sub-menu .mat-mdc-button {
  padding-left: 100px;
}
.sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .mat-mdc-button {
  padding-left: 120px;
}
.sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .mat-mdc-button {
  padding-left: 140px;
}
.sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .mat-mdc-button {
  padding-left: 160px;
}
.sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .mat-mdc-button {
  padding-left: 180px;
}
.sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .sub-menu .mat-mdc-button {
  padding-left: 200px;
}
.sub-menu .mat-mdc-button {
  padding-left: 40px;
}
.sub-menu.show {
  max-height: 500px;
  transition: max-height 0.25s ease-in;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/menu/vertical-menu/vertical-menu.component.scss","webpack://./src/app/theme/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EAoBI,6HAAA;AApBJ;AACI;EACI,WAAA;EACA,gBAAA;EACA,yBAAA;EAEA,kBAAA;AAAR;AACQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AACZ;AAEY;EAGI,yBAAA;AAAhB;;AAUA;EAEI,aAAA;EACA,gBAAA;EAGA,qCAAA;AARJ;ACtBQ;EAKQ,kBAAA;ADoBhB;ACzBQ;EAKQ,kBAAA;ADuBhB;AC5BQ;EAKQ,mBAAA;AD0BhB;AC/BQ;EAKQ,mBAAA;AD6BhB;AClCQ;EAKQ,mBAAA;ADgChB;ACrCQ;EAKQ,mBAAA;ADmChB;ACxCQ;EAKQ,mBAAA;ADsChB;AC3CQ;EAKQ,mBAAA;ADyChB;AAZI;EACI,kBAAA;AAcR;AAZI;EACI,iBAAA;EAGA,oCAAA;AAcR","sourcesContent":["@import \"../../../styles/mixins\"; \r\n\r\n.menu-item{\r\n    .mat-mdc-button{\r\n        width: 100%;\r\n        font-weight: 400;\r\n        text-transform: uppercase;\r\n        // height: 38px;\r\n        padding-left: 16px;\r\n        .mat-icon.menu-expand-icon {\r\n            position: absolute;\r\n            right: 10px;\r\n            top: 10px;\r\n        }\r\n        &.expanded{\r\n            .menu-expand-icon{\r\n                -webkit-transform: rotate(180deg);\r\n                -moz-transform: rotate(180deg);\r\n                transform: rotate(180deg);\r\n            }\r\n        }\r\n    }\r\n    /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */\r\n    // .mat-button-wrapper{\r\n    //     padding-left: 16px;\r\n    // }    \r\n}\r\n\r\n.sub-menu{\r\n    @include menu-level-padding('ltr');\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    -webkit-transition: max-height 0.25s ease-out;  \r\n    -moz-transition: max-height 0.25s ease-out;  \r\n    transition: max-height 0.25s ease-out;    \r\n    // .mat-mdc-button{\r\n    //     padding-left: 36px;      \r\n    // } \r\n    .mat-mdc-button{\r\n        padding-left: 40px;    \r\n    } \r\n    &.show{\r\n        max-height: 500px;\r\n        -webkit-transition: max-height 0.25s ease-in;\r\n        -moz-transition: max-height 0.25s ease-in;\r\n        transition: max-height 0.25s ease-in;\r\n    }    \r\n}","@mixin menu-level-padding($direction){\r\n    $elem: '';\r\n    @for $i from 3 through 10 {\r\n        $elem: if($i == 3, \".sub-menu\", selector-nest($elem, \".sub-menu\"));      \r\n        #{$elem + ' .mat-mdc-button'} { \r\n            @if $direction == \"rtl\" {\r\n                padding-right: 20px * $i; \r\n            } \r\n            @else{\r\n                padding-left: 20px * $i; \r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
